"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniMapsForLists = void 0;
var proj4_1 = require("proj4");
;
var proj4_2 = require("ol/proj/proj4");
var Map_1 = require("ol/Map");
var View_1 = require("ol/View");
var interaction_1 = require("ol/interaction");
var control_1 = require("ol/control");
var WKT_1 = require("ol/format/WKT");
proj4_1.default.defs([
    [
        'EPSG:27700',
        '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999601 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +no_defs +towgs84=446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894'
    ]
]);
var MiniMapsForLists = /** @class */ (function () {
    function MiniMapsForLists(baseLayerType, bingApiKey, EsdmOsmApiKey, baseLayerFactory, dataProjection, featureProjection, maxZoomLevel) {
        var _this = this;
        if (maxZoomLevel === void 0) { maxZoomLevel = 12; }
        this.baseLayerType = baseLayerType;
        this.bingApiKey = bingApiKey;
        this.EsdmOsmApiKey = EsdmOsmApiKey;
        this.baseLayerFactory = baseLayerFactory;
        this.dataProjection = dataProjection;
        this.featureProjection = featureProjection;
        this.maxZoomLevel = maxZoomLevel;
        this.initialised = false;
        this.init = function () {
            if (!_this.initialised) {
                var self_1 = _this;
                proj4_2.register(proj4_1.default);
                //load mini maps on list
                $(".search-result-listitem-map").each(function () {
                    if ($(this).data("wkt")) {
                        self_1.initMap($(this)[0], $(this).data("wkt"));
                    }
                    else {
                        $(this).hide();
                        $(this).prev(".search-result-listitem-logo").show();
                    }
                });
            }
        };
        this.initMap = function (mapElement, wktStr) {
            if (wktStr) {
                var format = new WKT_1.default();
                var feature = format.readFeature(wktStr, {
                    dataProjection: _this.dataProjection,
                    featureProjection: _this.featureProjection
                }); //parse WKT            
                var baseLyr = _this.baseLayerFactory.GetBaseLayerByType(_this.baseLayerType, _this.bingApiKey, _this.EsdmOsmApiKey);
                var map = new Map_1.default({
                    target: mapElement,
                    controls: control_1.defaults({
                        attribution: false,
                        rotate: false,
                        zoom: false
                    }),
                    interactions: interaction_1.defaults({
                        altShiftDragRotate: false,
                        dragPan: false,
                        doubleClickZoom: false,
                        keyboard: false,
                        mouseWheelZoom: false,
                        shiftDragZoom: false,
                        pinchZoom: false,
                        pinchRotate: false
                    }),
                    view: new View_1.default({
                        projection: _this.featureProjection
                    })
                });
                baseLyr.addLayerToMap(map, true);
                // Jquery to put the OpenLayers reference in the data-map attribute this is so we can 
                // get the object reference after initialisation, currently used in refreshMiniMaps() function
                $("#" + mapElement.id).data('map', map);
                map.getView().fit(feature.getGeometry().getExtent(), {
                    nearest: true,
                    maxZoom: _this.maxZoomLevel
                });
                //setTimeout(function () { map.getView().setZoom(16);},1000);            
            }
        };
        this.init();
    }
    // When the fullscreen option is selected on the Map tab, the mini-maps do not redraw themselves and are blank
    // on the tab change event we'll call this function to refresh/redraw the mini-maps
    MiniMapsForLists.prototype.refreshMiniMaps = function () {
        $(".search-result-listitem-map").each(function () {
            if ($(this).data("wkt")) {
                var map = $("#" + $(this)[0].id).data('map');
                map.updateSize();
            }
        });
    };
    return MiniMapsForLists;
}());
exports.MiniMapsForLists = MiniMapsForLists;
//# sourceMappingURL=MiniMapsForLists.js.map